import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import StepCard from './StepCard';

const progressBarDefaultPropStepArray = [];
const progressBarDefaultPropCanGoNext = () => false;
const progressBarDefaultPropStyle = {};
const progressBarDefaultPropNextButtonIds = [];
const ProgressBar = ({
  stepArray = progressBarDefaultPropStepArray,
  currentStep = 1,
  canGoNext = progressBarDefaultPropCanGoNext,
  gotoStep,
  style = progressBarDefaultPropStyle,
  className = '',
  maxStepForward = 0,
  nextButtonIds = progressBarDefaultPropNextButtonIds
}) => {
  return (
    <div
      className={`flex w-full px-6 mb-6 mt-2 ${className}`}
      id="integration-progress-bar"
      style={style}
    >
      {stepArray.length > 0 &&
        stepArray.map((step, i) => {
          return (
            <Fragment key={step.caption}>
              <div className="w-auto">
                <StepCard
                  stepNumber={i + 1}
                  caption={step.caption}
                  currentStep={currentStep}
                  canGoNext={canGoNext}
                  gotoStep={gotoStep}
                  maxStepForward={maxStepForward}
                  nextButtonIds={nextButtonIds}
                />
              </div>
              {stepArray.length !== i + 1 ? (
                <div
                  className={`h-px w-full my-auto mx-2 bg-gray-500 ${
                    currentStep > i + 1 ? 'bg-blue-60' : ''
                  }`}
                />
              ) : null}
            </Fragment>
          );
        })}
    </div>
  );
};

ProgressBar.propTypes = {
  stepArray: PropTypes.arrayOf(
    PropTypes.shape({
      caption: PropTypes.string.isRequired,
      number: PropTypes.number
    })
  ),
  currentStep: PropTypes.number,
  canGoNext: PropTypes.func,
  gotoStep: PropTypes.func.isRequired,
  style: PropTypes.shape({}),
  className: PropTypes.string,
  maxStepForward: PropTypes.number,
  nextButtonIds: PropTypes.arrayOf(PropTypes.string)
};

export default ProgressBar;
